namespace SorAraBul.PropertyManagement {
    export interface TenantDetailPanelForm {
        SelfReportedEmail: Serenity.Extensions.StaticTextBlock;
        MaskedTckn: Serenity.Extensions.StaticTextBlock;
        SelfReportedName: Serenity.Extensions.StaticTextBlock;
        SelfReportedSurname: Serenity.Extensions.StaticTextBlock;
        SelfReportedPhone: Serenity.Extensions.StaticTextBlock;
        BirthDate: CustomStaticTextBlock;
        HasoBkKrediNotuSonuc: Serenity.Extensions.StaticTextBlock;
        HasoBkKrediNotuRiskTablosu: Serenity.Extensions.StaticTextBlock;
        TenantName: Serenity.Extensions.StaticTextBlock;
        TenantSurname: Serenity.Extensions.StaticTextBlock;
        TenantPhone: Serenity.Extensions.StaticTextBlock;
        TenantEmail: Serenity.Extensions.StaticTextBlock;
        MaritalStatus: CustomStaticTextBlock;
        HasChildren: CustomStaticTextBlock;
        ChildrenCount: Serenity.Extensions.StaticTextBlock;
        ChildrenAges: Serenity.Extensions.StaticTextBlock;
        WorkingAdultsCount: Serenity.Extensions.StaticTextBlock;
        OccupationSelf: Serenity.Extensions.StaticTextBlock;
        OccupationSpouse: Serenity.Extensions.StaticTextBlock;
        EducationLevelSelf: CustomStaticTextBlock;
        EducationLevelSpouse: CustomStaticTextBlock;
        HasPet: CustomStaticTextBlock;
        PetTypesString: Serenity.Extensions.StaticTextBlock;
        Text: Serenity.Extensions.StaticTextBlock;
        OldCityName: Serenity.Extensions.StaticTextBlock;
        OldTownName: Serenity.Extensions.StaticTextBlock;
        OldQuarterName: Serenity.Extensions.StaticTextBlock;
        OldAddress: Serenity.Extensions.StaticTextBlock;
        OldAddressResidenceDurationText: Serenity.Extensions.StaticTextBlock;
    }

    export class TenantDetailPanelForm extends Serenity.PrefixedContext {
        static formKey = 'PropertyManagement.TenantDetailPanel';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TenantDetailPanelForm.init)  {
                TenantDetailPanelForm.init = true;

                var s = Serenity;
                var w0 = s.Extensions.StaticTextBlock;
                var w1 = CustomStaticTextBlock;

                Q.initFormType(TenantDetailPanelForm, [
                    'SelfReportedEmail', w0,
                    'MaskedTckn', w0,
                    'SelfReportedName', w0,
                    'SelfReportedSurname', w0,
                    'SelfReportedPhone', w0,
                    'BirthDate', w1,
                    'HasoBkKrediNotuSonuc', w0,
                    'HasoBkKrediNotuRiskTablosu', w0,
                    'TenantName', w0,
                    'TenantSurname', w0,
                    'TenantPhone', w0,
                    'TenantEmail', w0,
                    'MaritalStatus', w1,
                    'HasChildren', w1,
                    'ChildrenCount', w0,
                    'ChildrenAges', w0,
                    'WorkingAdultsCount', w0,
                    'OccupationSelf', w0,
                    'OccupationSpouse', w0,
                    'EducationLevelSelf', w1,
                    'EducationLevelSpouse', w1,
                    'HasPet', w1,
                    'PetTypesString', w0,
                    'Text', w0,
                    'OldCityName', w0,
                    'OldTownName', w0,
                    'OldQuarterName', w0,
                    'OldAddress', w0,
                    'OldAddressResidenceDurationText', w0
                ]);
            }
        }
    }
}
